import { lazy } from 'react'

export const FeelingsToAchieve = lazy(() => import('./v1/FeelingsToAchieve'))
export const FeelingsToAchieveV2 = lazy(
  () => import('./v2/FeelingsToAchieveV2'),
)
